module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Digital_Chapters"
  }, [_c('span', [_vm._v("Praise for the Works of B. Hughes-Millman")])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“PURGATORY’S ANGEL is an awesome paranormal romance that fans of Sherrilyn Kenyon and J.R. Ward will really enjoy…No simple angels here.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("- Examiner’s Women in Horror Author, Danielle DeVor")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“PURGATORY’S ANGEL is a must read! From the first chapter to the final chapter it keeps you wanting more. The battle between good and evil in its finest. B Hughes-Millman keeps you guessing to the end.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('i', [_vm._v("- Dana Thornock, Book Reviewer")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“DARKEST FOREST is constructed properly and the characters developed in a most satisfying way. It turned out to be a compelling story line which I cannot wait to follow into her next novel and the series beyond.” ")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("- R. P. McCabe, Mystery Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“B Hughes-Millman does it again in this installment of her Black Casket series. The execution of the emotional conflicts couldn't have been done better. I'll read this again and recommend it to everyone.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("- Nichole Severn, Book Reviewer ")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“I love RESURRECTION’S ANGEL! The suspense, the plot twists, the characters - great story! – pass the hanky!” ")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("– D. B. Sieders, Urban Fantasy Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“With compelling characters, interesting subplots and plenty of paranormal action PURGATORY’S ANGEL is the kind of book that keeps one up at night! Kudos to Ms. Hughes-Millman for some of the most well-written action scenes this reviewer has ever had the pleasure of reading!” ")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("- Chantel Hardge, InD'Tale")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v(" “I loved RESURRECTION’S ANGEL. It kept me on the edge of my seat and my mind engrossed. I never knew what was happening next! All through the book I kept waiting for a dull part but it never happened. I read this one in less than a day!” ")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("- MeLisa Holden Bruner, Book Reviewer")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_vm._v("“I think it was a combination of what was happening in the story with how well everything was written (how enticing, how fast-paced, how attractive the narration was) with my personal love for the theme, but whatever it was, it kept me reading.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("-Misanthropist Book Reviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph1__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 66
// module chunks = 0